import { ButtonProps, MenuButton, MenuButtonProps } from '@chakra-ui/react';
import React, { forwardRef } from 'react';

const KS_Menu = (props: MenuButtonProps & ButtonProps, ref: any) => {
  return <MenuButton {...props} ref={ref} />;
};

export default forwardRef(KS_Menu);
